import { SizeUnitType } from '@meitu/saas-editor-core/es/utils/unit-kit';
import request from '@meitu/saas-editor-ui/es/request';
import { FetchInternalDesignerRespone, FetchSizeListParams } from './index.d';

export const fetchSizeList = async function (params: FetchSizeListParams) {
    const data = {
        ...params,
    };

    return await fetchDesignerSizeList(data);
};

export const fetchDesignerSizeList = async function name(params: FetchSizeListParams) {
    const res = await request<FetchInternalDesignerRespone>('/seal_pie/template_size_list.json', {
        method: 'GET',
        params,
    });
    return (
        res.data.response.list.map((el, index) => {
            return { ...el, unit: SizeUnitType.px, isCheck: false, id: index };
        }) || []
    );
};
